import { useNavigate, useLocation } from "react-router-dom";

// Custom hook to access navigation functionality
export const useAppNavigate = useNavigate;

// Custom hook to access location information
export const useAppLocation = useLocation;
